import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import LogoSvgComponent from "./../Logo/LogoSvg.component";
import "./Header.component.scss";

const HeaderComponent = ({
  Clasificaciones
}) => {
  const [clasificaciones, setClasificaciones] = useState([]);

  useEffect(() => {
    setClasificaciones(Clasificaciones);
  }, [Clasificaciones]);

  return (
    <Navbar expand="lg" className="Header">
      <Link to="/" className="Header__Logo">
        <LogoSvgComponent />
      </Link>
      <Navbar.Toggle aria-controls="headerOpciones" />
      <Navbar.Collapse id="headerOpciones">
        <Nav className="Header__Catalogo">
          {clasificaciones.map((clasificacion) => {
            return (
              <NavLink
                key={clasificacion.id}
                to={`/Catalogo/${clasificacion.datos.Cabecera}`}
                hash={`${clasificacion.id}`}
                className="Header__Catalogo--Link"
                activeClassName="Header__Catalogo--Link-Actual"
              >
                {clasificacion.datos.Cabecera}
              </NavLink>
            );
          })}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default HeaderComponent;
